import React, { useState } from "react";

import Grouping from "../../point/Grouping";
import { TAKS_IMPORT } from "../../../config/lang";
import { translate } from "../../../util/util";

export default function GroupingAction({ checked, rows, currentUser, onDone, setGroupingActive }) {
  const [open, setOpen] = useState(false);
  const [clearPointsTrigger, setClearPointsTrigger] = useState(0);

  const checkedRowsIds = checked;

  const handleGroupPopup = () => {
    setOpen(prev => {
      const next = !prev;
      if (!next) {
        // popup closed: reset, stop grouping mode, and let the table refresh
        setClearPointsTrigger(t => t + 1);
        if (setGroupingActive) setGroupingActive(false);
        if (onDone) onDone();
      }
      return next;
    });
  };

  // Grouping reports its current mode here. Point selection is only meaningful while actually
  // building/editing a group (new/edit); returning to the list clears the table selection.
  const getCurrentGroupData = type => {
    if (type === "new" || type === "edit") {
      if (setGroupingActive) setGroupingActive(true);
    } else if (type === "list") {
      if (setGroupingActive) setGroupingActive(false);
      if (onDone) onDone();
    }
  };

  return (
    <>
      <button
        className="mp-toggle-btn pt-bulk-btn"
        onClick={handleGroupPopup}>
        <span className="material-symbols-outlined">workspaces</span>
        {translate(TAKS_IMPORT, "grouping_btn_name", currentUser.language)}
      </button>
      <Grouping
        isActive={open}
        handleGroupPopup={handleGroupPopup}
        checkedRowsIds={checkedRowsIds}
        getCurrentGroupData={getCurrentGroupData}
        filterUrlKeys={{}}
        onAllPointsAdded={() => {}}
        clearPointsTrigger={clearPointsTrigger}
      />
    </>
  );
}
